export const LS_KEY = "gd_streak_app_v1";
export const PRAYERS = ["Fajr", "Dhuhr", "Asr", "Maghrib", "Isha"];

export const SLIP_REASONS = [
  "Boredom",
  "Stress",
  "Loneliness",
  "Fatigue",
  "Peer pressure",
  "Triggered by media",
  "Relationship issue",
  "Work pressure",
  "Just happened",
  "Other",
];

export const TEMPTATION_ACTIONS = [
  {
    key: "walk",
    label: "Go for a short walk (2–5 minutes)",
  },
  {
    key: "wudhu",
    label: "Make wudhu / wash your face and hands",
  },
  {
    key: "dhikr",
    label: "Do dhikr for 2 minutes (SubhanAllah, Alhamdulillah, Allahu Akbar)",
  },
  {
    key: "quran",
    label: "Read 1 page of Qur'an",
  },
  {
    key: "dua",
    label: "Make du'a (ask Allah to protect you from this urge)",
  },
  {
    key: "phone",
    label: "Put the phone away for 5 minutes",
  },
];

export const DEFAULT_DEEDS = [
  "Read a page of Qur'an",
  "Make 10 minutes of dhikr",
  "Give a small sadaqah",
  "Text a family member with kindness",
  "Pray 2 rak'ah of salah",
  "Seek forgiveness (istighfar) 100x",
  "Lower the gaze intentionally today",
  "Go for a walk and reflect (tafakkur)",
  "Make du'a for someone else",
  "Learn one new Islamic ruling or hadith",
];
